import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import DownloadApp from './DownloadApp';
import Contact from './Contact';
import Footer from './Footer';

const LandingPage: React.FC = () => {
    return (
        <>
            <Header />
            <Hero />
            <Features />
            <DownloadApp />
            <Contact />
            <Footer />
        </>
    );
};

export default LandingPage;
